import React, { useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Bookopen from "../../common/assets/images/book-open-02 (1).png";
import { CodeContext } from "../pages/Coder/Coder";
import { renderSeeReference, renderTextWithCodeLinks } from "./codeLinkUtils";
import { getItemCodes, handleDragStartLogic, highlightText } from "./codeBookUtils";
const AccordionItem = ({
  item,
  activeTab,
  searchQuery,
  searchByCodeId,
  isTopLevel,
  dispatch,
  setActiveTab,
  setActiveIcon,
  isLockedCoder,
  nondraggablecode,
  onCodeNavigate,
  onAcsNavigate,
  onNcaNavigate,
  onFieldCodeNavigate,
  onSeeNavigate,
  onAchiBlockNavigate,
}) => {
  const { copiedCodes, setCopiedCodes } = useContext(CodeContext);
  const [isCopied, setIsCopied] = useState(false);
  const [localIsOpen, setLocalIsOpen] = useState(false);

  const { onChangeCodeBook } = useSelector((state) => state.codeBook);

  const isHighlightedById = searchByCodeId && item.id === searchByCodeId;
    const handleParentClick = (e) => {
    if (
      (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
      item.children?.length > 0
    ) {
      e.stopPropagation();
      // Pass the active tab context to the parent navigation
      onFieldCodeNavigate(item.id, 'parent', activeTab);
      return;
    }
    handleCopyCode(e);
  };

  useEffect(() => {
    if (searchByCodeId) {
      const isTargetOrParent =
        item.id === searchByCodeId ||
        item.children?.some((child) => child.id === searchByCodeId);
      setLocalIsOpen(isTargetOrParent || !!item.matches);
    } else if (searchQuery.length > 1) {
      setLocalIsOpen(!!item.matches);
    } else {
      setLocalIsOpen(false);
    }
  }, [searchQuery, searchByCodeId, item.matches, item.id, item.children]);
  // useEffect(() => {
  //   if (
  //     searchQuery.length > 2 &&
  //     item.children?.some((child) => child.matches)
  //   ) {
  //     setLocalIsOpen(true); // Auto-open only if a child matches
  //   } else if (searchQuery.length < 3) {
  //     setLocalIsOpen(false); // Close if no search or short query
  //   }
  // }, [searchQuery, item.children]);
  // useEffect(() => {
  //   if (searchQuery.length > 1) {
  //     // Check if the item or any of its descendants have matches
  //     const hasMatches = item.matches || (item.children?.some(child => child.matches || child.children?.some(c => c.matches)));
  //     setLocalIsOpen(hasMatches);
  //   } else {
  //     setLocalIsOpen(false);
  //   }
  // }, [searchQuery, item]);

  //     useEffect(() => {
  //   if (searchQuery.length > 1) {
  //     // Only open if a *child* matches, not when the parent itself matches
  //     const childHasMatches =
  //       item.children?.some(
  //         (child) => child.matches || child.children?.some((c) => c.matches)
  //       ) || false;

  //     // Open only if a descendant matched
  //     setLocalIsOpen(childHasMatches);
  //   } else {
  //     setLocalIsOpen(false);
  //   }
  // }, [searchQuery, item]);

  const toggleOpen = () => {
    setLocalIsOpen(!localIsOpen);
  };

  const handleAcsFunction = (acsCode) => {
    onAcsNavigate(acsCode);
    // console.log("navigate click");
    dispatch(updateAcsCode(acsCode));
    dispatch(setActiveTab("Australian Coding Standard"));
    dispatch(setActiveIcon("Coding"));
  };
  const handleNationalSearchRef = (ncaCode) => {
    onNcaNavigate(ncaCode);
    dispatch(updateNcaCode(null));
    setTimeout(() => {
      dispatch(updateNcaCode(ncaCode));
    }, 0);
    dispatch(setActiveIcon("References"));
    dispatch(setActiveTab("National Coding Advice"));
  };

  const codes = getItemCodes(item, activeTab);
  const draggableCodes = codes.filter((code) => {
    if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") {
      // return true;
      return code.includes("-");
    } else {
      return !code.includes("-");
    }
  });

  // Non drggable code functionlity -Hyphen codes
  const isHyphenExtensionCode = (code = "") => {
    if (typeof code !== "string") return false;

    // Matches:
    // Z50.3-       → trailing hyphen
    // A23.-†, A23.-+, M49.1-* → special hyphen
    return code.endsWith("-") || /-\*|-\+|-\†$/.test(code);
  };

  const handleCodeClick = (code) => {
    if (!code) return;
    // No more early return for ACHI Tabular/Index — let it navigate too.

    let cleanedCode = code.trim().replace(/-[†*+]$/, "");
    if (cleanedCode.endsWith("-")) cleanedCode = cleanedCode.slice(0, -1);
    cleanedCode = cleanedCode
      .replace(/^[\(\[\{]+/, "")
      .replace(/[\)\]\}]+$/, "");

    onCodeNavigate(cleanedCode);
  };
  const hasMixedCodes =
    item.description?.split(/\s+/).some((p) => isHyphenExtensionCode(p)) &&
    item.description?.split(/\s+/).some((p) => !isHyphenExtensionCode(p));
  // Completed
  const handleDragStart = useCallback(
    (e, draggableCodes) => {
      if (isLockedCoder) {
        e.preventDefault();
        return;
      }
      handleDragStartLogic(e, draggableCodes, activeTab);
      // console.log("Codes being dragged:", draggableCodes,activeTab);
    },
    [activeTab, isLockedCoder],
  );
  const handleCopyCode = (e) => {
    if (isLockedCoder) {
      toast.error("Episode is locked.");
      return;
    }
    if (
      (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
      (!item.children || item.children.length === 0)
    ) {
      // Tabular view logic
      if (draggableCodes.length > 0) {
        const cleanedCodes = draggableCodes.map(
          (code) =>
            code
              ?.trim()
              .replace(/^\(+/, "") // remove leading (
              .replace(/\)+$/, ""), // remove trailing )
        );

        const codesString = cleanedCodes.join(",");
        // console.log(codesString, "copy code========");
        navigator.clipboard
          .writeText(codesString)
          .then(() => {
            setIsCopied(true);
            setCopiedCodes(codesString.split(","));
            setTimeout(() => setIsCopied(false), 3000);
          })
          .catch((err) => {
            console.error("Clipboard copy error:", err); // Log the error for debugging
            if (err instanceof Error) {
              toast.error("Failed to copy: " + err.message);
            } else {
              toast.error("Failed to copy: An unknown error occurred.");
            }
          });
      }
    } else if (
      (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index") &&
      draggableCodes.length > 0
    ) {
      // Index view logic
      const cleanedCodes = draggableCodes.map(
        (code) =>
          code
            ?.trim()
            .replace(/^\(+/, "") // remove leading (
            .replace(/\)+$/, ""), // remove trailing )
      );

      const codesString = cleanedCodes.join(",");
      // console.log(codesString, "copy code========");
      navigator.clipboard
        .writeText(codesString)
        .then(() => {
          setIsCopied(true);
          setCopiedCodes(codesString.split(","));
          setTimeout(() => setIsCopied(false), 3000);
        })
        .catch((err) => {
          // console.error("Clipboard copy error:", err); // Log the error for debugging
          if (err instanceof Error) {
            toast.error("Failed to copy: " + err.message);
          } else {
            toast.error("Failed to copy: An unknown error occurred.");
          }
        });
    }
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  const findExactParentItem = (items, code) => {
  const searchInTree = (nodes, parentPath = []) => {
    for (const node of nodes) {
      // Check if this is a parent item (has children)
      if (node.children?.length > 0) {
        // Check for exact match - either the name exactly matches the code
        // or the name contains the code as a separate token
        const nameParts = node.name.split(/\s+/);
        const hasExactMatch = nameParts.some(part => 
          part.trim() === code || 
          part.trim().replace(/[^A-Z0-9]/g, '') === code.replace(/[^A-Z0-9]/g, '')
        );
        
        if (hasExactMatch) {
          return node;
        }
      }
      
      // Search children
      if (node.children) {
        const found = searchInTree(node.children, [...parentPath, node]);
        if (found) return found;
      }
    }
    return null;
  };
  
  return searchInTree(items);
};
const handleParentNavigate = (code, sourceItemId) => {
  if (!code) return;
  
  let cleanedCode = code.trim();
  // Remove any trailing special characters
  cleanedCode = cleanedCode.replace(/-\†|\-\+|\-\*$/g, '');
  if (cleanedCode.endsWith('-')) cleanedCode = cleanedCode.slice(0, -1);
  
  // Determine which tab we're currently in
  let targetTab = activeTab;
  if (activeTab === "ACHI Tabular") {
    targetTab = "ACHI Tabular";
  } else if (activeTab === "ICD 10 AM Tabular") {
    targetTab = "ICD 10 AM Tabular";
  } else {
    // If we're in Index view, determine based on the code type
    targetTab = isAchiCode(cleanedCode) ? "ACHI Tabular" : "ICD 10 AM Tabular";
  }
  
  // Find the parent item in the correct tabular data
  const tabularData = tabsConfig.find((t) => t.name === targetTab)?.data || [];
  const parentItem = findExactParentItem(tabularData, cleanedCode);
  
  if (parentItem) {
    // Navigate to show the parent hierarchy
    onFieldCodeNavigate(parentItem.id, sourceItemId, 'parent', targetTab);
  } else {
    // Fallback: try to navigate to the code
    onFieldCodeNavigate(cleanedCode, sourceItemId, 'parent', targetTab);
  }
};
  // More comprehensive medical code detection
  const isMedicalCode = (text) => {
    if (!text || typeof text !== "string") return false;
    const trimmed = text.trim();
    if (!trimmed) return false;

    const cleanText = trimmed
      .replace(/^[\(\[\{]+/, "")
      .replace(/[\)\]\}]$/, "");

    const patterns = [
      // ICD-10 codes
      /^[A-Z][0-9]{2}\.[0-9]{1,2}$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}-[†*+]$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}[†*+]$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}-$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}\*$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}\+$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}†$/,

      // Simple ICD codes (without dot)
      /^[A-Z][0-9]{2,4}$/,

      // ACHI codes
      /^[0-9]{5,6}$/,
      /^[0-9]{5,6}-[†*+]$/,
      /^[0-9]{4,6}-[0-9]{2}(?:-[†*+])?$/,

      // Morphology codes
      /^M[0-9]{4}\/[0-9]$/,
      /^M[0-9]{4}\/[0-9][†*+]$/,
      /^M[0-9]{4}\/[0-9]-[†*+]$/,

      // General patterns
      /^[A-Za-z][0-9]{2}\.[0-9]{1,2}$/,
      /^[A-Za-z][0-9]{2}\.[0-9]{1,2}-$/,
      /^[A-Za-z][0-9]{2}\.[0-9]{1,2}\*$/,
      /^[A-Za-z][0-9]{2}\.[0-9]{1,2}\+$/,
      /^[A-Za-z][0-9]{2}\.[0-9]{1,2}†$/,

      /^[A-Z][0-9]{2}\.[0-9]{1,2}$/,
      /^[A-Z][0-9]{2}\.[0-9]{1,2}[†*+]?$/,
    ];

    return patterns.some((pattern) => pattern.test(cleanText));
  };
  return (
    // <div key={"shbfsh"} className={`codebook-wrapper accordion-item ${isHighlightedById ? 'highlighted-item' : ''}`}>
    // REPLACE WITH
    <div
      key={"shbfsh"}
      data-item-id={item.id}
      className={`codebook-wrapper accordion-item ${isHighlightedById ? "highlighted-item" : ""}`}
    >
      {isCopied && ( // Conditionally render the button
        <button className="code-copied-button">
          Code Copied{" "}
          <img src={Bookopen} alt="plus" className="codebook-copy-icon" />
        </button>
      )}
      <div className="accordion-header" onClick={toggleOpen}>
        <div
          className={`header-content ${isHighlightedById ? "highlighted-by-id" : ""}`}
        >
          {item.children?.length > 0 && (
            <span className="accordion-icon">{localIsOpen ? "▼" : "▶"}</span>
          )}
         <span
  className={`item-name ${
    (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
    item.children?.length > 0
      ? "parent-hierarchy-link"
      : ""
  }`}
  onClick={handleParentClick}
  draggable={
    !isLockedCoder &&
    (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
    (!item.children || item.children.length === 0)
  }
  onDragStart={
    !isLockedCoder &&
    (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
    (!item.children || item.children.length === 0)
      ? (e) => handleDragStart(e, draggableCodes)
      : null
  }
  style={{
    color: (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") && 
            item.children?.length > 0 
            ? '#0066cc' 
            : (!isLockedCoder && draggableCodes.length > 0 && 
               (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") && 
               (!item.children || item.children.length === 0)
               ? "blue"
               : "inherit"),
    textDecoration: (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") && 
                     item.children?.length > 0 
                     ? 'underline' 
                     : (draggableCodes.length > 0 && 
                        (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") && 
                        (!item.children || item.children.length === 0)
                        ? "underline"
                        : "none"),
    cursor: (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") && 
            item.children?.length > 0 
            ? 'pointer' 
            : 'default',
    fontWeight: isTopLevel || item.children?.length > 0 ? "bold" : "normal",
  }}
>
  {highlightText(item.name, searchQuery, onChangeCodeBook)}
</span>
          <span
            className="item-description"
            onClick={handleCopyCode}
            draggable={
              activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular"
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular"
                ? null
                : draggableCodes.length > 0
                  ? (e) => handleDragStart(e, draggableCodes)
                  : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index")
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index")
                  ? "underline"
                  : "none",
            }}
          >
            {/* <span className="item-descrpition-value">
              {highlightText(item.description, searchQuery,onChangeCodeBook)}
            </span> */}
            {/* {item.description ? (
              <span className="item-descrpition-value">
                {item.description.split(/\s+/).map((rawPart, index) => {
                  const part = rawPart.trim();
                  const clickable = isHyphenExtensionCode(part) && !hasMixedCodes;

                  return (
                    <span
                      key={index}
                      className={clickable ? "code-underline" : ""}
                      onClick={() => clickable && handleCodeClick(part)}
                      style={{
                        cursor: clickable ? "pointer" : "pointer",
                         marginRight: clickable ? "8px" : "0px",
                        // textDecoration: clickable ? "underline" : "none",

                      }}
                    >
                      {highlightText(part, searchQuery, onChangeCodeBook)}
                    </span>
                  );
                })}
              </span>
            ) : null} */}

            {item.description ? (
              <span className="item-descrpition-value">
                {activeTab === "ICD 10 AM Tabular" ||
                activeTab === "ACHI Tabular"
                  ? highlightText(
                      item.description,
                      searchQuery,
                      onChangeCodeBook,
                    )
                  : (() => {
                      const parts = item.description.split(/\s+/);
                      const elements = [];
                      let i = 0;

                      while (i < parts.length) {
                        const part = parts[i].trim();
                        const next = parts[i + 1]?.trim();

                        // NEW: bare ACHI code (no hyphen) immediately followed by [block]
                        const bareAchiMatch = /^[0-9]{4,6}$/.test(part);
                        const blockMatch = next?.match(/^\[([0-9]+)\]$/);

                        if (bareAchiMatch && blockMatch) {
                          const codePrefix = part;
                          const blockNumber = blockMatch[1];
                          elements.push(
                            <span key={i}>
                              <span
                                className="code-underline"
                                onClick={() =>
                                  onAchiBlockNavigate?.(codePrefix, blockNumber)
                                }
                                style={{
                                  marginRight: "2px",
                                  cursor: "pointer",
                                }}
                                title={`Click to view code ${codePrefix} in block ${blockNumber}`}
                              >
                                {highlightText(
                                  part,
                                  searchQuery,
                                  onChangeCodeBook,
                                )}
                              </span>
                              <span style={{ marginRight: "5px" }}>
                                {highlightText(
                                  next,
                                  searchQuery,
                                  onChangeCodeBook,
                                )}
                              </span>
                            </span>,
                          );
                          i += 2; // consumed both tokens
                          continue;
                        }
                        let cleanPart = part;
                        let hasParentheses = false;

                        const parenMatch = part.match(/\(([^)]+)\)/);
                        if (parenMatch) {
                          const insideParen = parenMatch[1];
                          if (isMedicalCode(insideParen)) {
                            cleanPart = insideParen;
                            hasParentheses = true;
                          }
                        }

                        const isCode = isMedicalCode(cleanPart);
                        let codeToUse = cleanPart;
                        let displayText = part;

                        if (isCode) {
                          codeToUse = cleanPart;
                          displayText = hasParentheses
                            ? `(${cleanPart})`
                            : cleanPart;
                        } else {
                          const codeAtEndMatch = part.match(
                            /\s([A-Z][0-9]{2}\.[0-9]{1,2})$/,
                          );
                          if (codeAtEndMatch) {
                            const codeAtEnd = codeAtEndMatch[1];
                            if (isMedicalCode(codeAtEnd)) {
                              const textWithoutCode = part.replace(
                                /\s[A-Z][0-9]{2}\.[0-9]{1,2}$/,
                                "",
                              );
                              elements.push(
                                <span key={i}>
                                  <span>
                                    {highlightText(
                                      textWithoutCode,
                                      searchQuery,
                                      onChangeCodeBook,
                                    )}
                                  </span>
                                  <span
                                    className="code-underline"
                                    onClick={() => handleCodeClick(codeAtEnd)}
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                    }}
                                    title="Click to search in Tabular view"
                                  >
                                    {highlightText(
                                      codeAtEnd,
                                      searchQuery,
                                      onChangeCodeBook,
                                    )}
                                  </span>
                                </span>,
                              );
                              i += 1;
                              continue;
                            }
                          }

                          const codeWithoutSpaceMatch = part.match(
                            /([A-Z][0-9]{2}\.[0-9]{1,2})$/,
                          );
                          if (codeWithoutSpaceMatch) {
                            const codeAtEnd = codeWithoutSpaceMatch[1];
                            if (isMedicalCode(codeAtEnd)) {
                              const textWithoutCode = part.replace(
                                /[A-Z][0-9]{2}\.[0-9]{1,2}$/,
                                "",
                              );
                              elements.push(
                                <span key={i}>
                                  <span>
                                    {highlightText(
                                      textWithoutCode,
                                      searchQuery,
                                      onChangeCodeBook,
                                    )}
                                  </span>
                                  <span
                                    className="code-underline"
                                    onClick={() => handleCodeClick(codeAtEnd)}
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                    }}
                                    title="Click to search in Tabular view"
                                  >
                                    {highlightText(
                                      codeAtEnd,
                                      searchQuery,
                                      onChangeCodeBook,
                                    )}
                                  </span>
                                </span>,
                              );
                              i += 1;
                              continue;
                            }
                          }
                        }

                        elements.push(
                          <span
                            key={i}
                            className={isCode ? "code-underline" : ""}
                            onClick={() => isCode && handleCodeClick(codeToUse)}
                            style={{
                              marginRight: "5px",
                              cursor: isCode ? "pointer" : "default",
                            }}
                            title={
                              isCode ? "Click to search in Tabular view" : ""
                            }
                          >
                            {highlightText(
                              displayText,
                              searchQuery,
                              onChangeCodeBook,
                            )}
                          </span>,
                        );
                        i += 1;
                      }

                      return elements;
                    })()}
              </span>
            ) : null}

            {/* {item?.acs ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="acs-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleAcsFunction(item?.acs);
                  }}
                >
                  ACS
                </button>{" "}
              </span>
            ) : (
              ""
            )}
          </span> */}
            {item?.acs && activeTab !== "ICD 10 AM Index" ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="acs-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleAcsFunction(item?.acs);
                  }}
                >
                  ACS
                </button>{" "}
              </span>
            ) : (
              ""
            )}
            {item?.nca && activeTab !== "ICD 10 AM Index" ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="nca-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleNationalSearchRef(item?.nca);
                  }}
                >
                  Advice
                </button>{" "}
              </span>
            ) : (
              ""
            )}
          </span>
          {item.nonessential && (
            <span
              className="font_violet"
              style={{ marginLeft: !item.description ? "5px" : "0px" }}
            >
              ({highlightText(item.nonessential, searchQuery)})
            </span>
          )}
          {item.nec && (
            <span
              className="font_blue"
              style={{ marginLeft: !item.description ? "5px" : "0px" }}
            >
              {highlightText(item.nec, searchQuery)}
            </span>
          )}
          {item.see && (
            <span className="font_purple">
              {" "}
              –{" "}
              {activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index"
                ? renderSeeReference(item.see, {
                    searchQuery,
                    onChangeCodeBook,
                    onNavigate: (term) => onSeeNavigate?.(term, item.id),
                  })
                : highlightText(item.see.replace(/^ \s*/, ""), searchQuery)}
            </span>
          )}
          {item.seealso && (
            <span className="font_orange">
              {" "}
              –{" "}
              {activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index"
                ? renderSeeReference(item.seealso, {
                    searchQuery,
                    onChangeCodeBook,
                    onNavigate: (term) => onSeeNavigate?.(term, item.id),
                  })
                : highlightText(item.seealso.replace(/^ \s*/, ""), searchQuery)}
            </span>
          )}
          {item.note && (
            <div className="font_yellow">
              <b>Note</b>:{" "}
              {renderTextWithCodeLinks(item.note, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-note`,
              })}
            </div>
          )}
          {item.inclusion && (
            <div className="font_green">
              <b>Includes</b> :{" "}
              {renderTextWithCodeLinks(item.inclusion, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-inclusion`,
              })}
            </div>
          )}
          {item.useAdditional && (
            <div className="font_blud">
              <b>useAdditional</b> :{" "}
              {renderTextWithCodeLinks(item.useAdditional, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-useAdditional`,
              })}
            </div>
          )}
          {item.exclusion && (
            <div className="font_red">
              <b>Excludes</b> :{" "}
              {renderTextWithCodeLinks(item.exclusion, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-exclusion`,
              })}
            </div>
          )}

          {item.codeas && (
            <span className="font_codeas">
              {" "}<b>Codeas</b> :{" "}
              {renderTextWithCodeLinks(item.codeas, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-codeas`,
              })}
            </span>
          )}
          {/* {item.codeas && (
            <div className="font_codeas">
              <b>Codeas</b> : {highlightText(item.codeas, searchQuery)}
            </div>
          )} */}
          {item.codealso && (
            <div className="font_codealso">
              <b>Codealso</b> :{" "}
              {renderTextWithCodeLinks(item.codealso, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-codealso`,
              })}
            </div>
          )}
          {item.codeto && (
            <div className="font_purple11">
              <b>Codeto</b> :{" "}
              {renderTextWithCodeLinks(item.codeto, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-codeto`,
              })}
            </div>
          )}
          {item.codefirst && (
            <div className="font_codefirst">
              <b>Codefirst</b> :{" "}
              {renderTextWithCodeLinks(item.codefirst, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-codefirst`,
              })}
            </div>
          )}
          {item.inclusional && (
            <div className="font_inclusional">
              <b>Inclusional</b> :{" "}
              {renderTextWithCodeLinks(item.inclusional, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-inclusional`,
              })}
            </div>
          )}
          {item.definition && (
            <div className="font_pink">
              <b>Definition</b> :{" "}
              {renderTextWithCodeLinks(item.definition, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-definition`,
              })}
            </div>
          )}

          {item.stylednote && (
            <div className="font_blue">
              <b>Stylednote</b> :{" "}
              {renderTextWithCodeLinks(item.stylednote, {
                searchQuery,
                onChangeCodeBook,
                onCodeClick: onFieldCodeNavigate,
                onBlockNavigate: onAchiBlockNavigate,
                keyPrefix: `${item.id}-stylednote`,
              })}
            </div>
          )}
        </div>
      </div>
      {localIsOpen && item.children?.length > 0 && (
        <div className="accordion-children">
          {item.children.map((child) => (
            <AccordionItem
              key={child.id}
              item={child}
              activeTab={activeTab}
              searchByCodeId={searchByCodeId}
              searchQuery={searchQuery}
              setActiveTab={setActiveTab}
              dispatch={dispatch}
              setActiveIcon={setActiveIcon}
              isLockedCoder={isLockedCoder}
              onCodeNavigate={onCodeNavigate}
              onFieldCodeNavigate={onFieldCodeNavigate}
              onAcsNavigate={onAcsNavigate}
              onNcaNavigate={onNcaNavigate}
              onSeeNavigate={onSeeNavigate}
              onAchiBlockNavigate={onAchiBlockNavigate}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(AccordionItem);
